import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { convertToSwitchBoardUrl } from "@faire/retailer-visitor-shared/lib/webSocketUrls";
import { isWindowUndefined } from "@faire/web--source/common/server-side-rendering/isWindowUndefined";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { WebSocketMessageChannel } from "@faire/web--source/messenger/MessageChannel/WebSocketMessageChannel";
export var WebSocketChannelStore = function WebSocketChannelStore() {
    "use strict";
    var _this = this;
    _class_call_check(this, WebSocketChannelStore);
    this.channelByUrl = {};
    this.hiddenChannelByUrl = {};
    this.getOrInitChannel = function(url) {
        if (isWindowUndefined()) {
            return undefined;
        }
        var _this_channelByUrl_url;
        var channel = (_this_channelByUrl_url = _this.channelByUrl[url]) !== null && _this_channelByUrl_url !== void 0 ? _this_channelByUrl_url : new WebSocketMessageChannel(url);
        _this.channelByUrl[url] = channel;
        return channel;
    };
    this.closeChannel = function(url) {
        var _this_channelByUrl_url, _this_hiddenChannelByUrl_switchBoardUrl;
        (_this_channelByUrl_url = _this.channelByUrl[url]) === null || _this_channelByUrl_url === void 0 ? void 0 : _this_channelByUrl_url.close();
        _this.channelByUrl[url] = undefined;
        var switchBoardUrl = convertToSwitchBoardUrl(url);
        (_this_hiddenChannelByUrl_switchBoardUrl = _this.hiddenChannelByUrl[switchBoardUrl]) === null || _this_hiddenChannelByUrl_switchBoardUrl === void 0 ? void 0 : _this_hiddenChannelByUrl_switchBoardUrl.forEach(function(channel) {
            return channel.close();
        });
        _this.hiddenChannelByUrl[switchBoardUrl] = undefined;
    };
};
WebSocketChannelStore.get = singletonGetter(WebSocketChannelStore);
